import { render, staticRenderFns } from "./TheResumenVentaDetallado.vue?vue&type=template&id=c37ecbc6&scoped=true&"
import script from "./TheResumenVentaDetallado.vue?vue&type=script&lang=js&"
export * from "./TheResumenVentaDetallado.vue?vue&type=script&lang=js&"
import style0 from "./TheResumenVentaDetallado.vue?vue&type=style&index=0&id=c37ecbc6&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37ecbc6",
  null
  
)

export default component.exports